import React, { useState } from 'react';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import { FaRegCircleXmark } from 'react-icons/fa6';
import MuxVideoPlayer from './MuxVideoPlayer';

const VideoTrailer = ({ selectedVideo }) => {
	const [showModal, setShowModal] = useState(false);

	if (selectedVideo?.type !== 'class' || !selectedVideo?.muxTrailerLink) return null;

	const openModal = () => setShowModal(true);
	const closeModal = () => setShowModal(false);

	return (
		<>
			{/* Watch Trailer Button */}
			<div className="watch-trailer-btn" onClick={openModal}>
				<SlideshowIcon style={{ fontSize: '24px', color: '#097DAC' }} />
				<p>Watch Trailer</p>
			</div>
			{/* Modal */}
			{showModal && (
				<div className="modal-overlay-trailer justify-content-md-start">
					<div className="modal-content-trailer ">
						<div className="modal-head-trailer">
							<h3>Trailer</h3>
							<a onClick={closeModal}>
								<FaRegCircleXmark color="white" />
							</a>
						</div>

						<div className="trailer-video">
							{/* <iframe
								width="100%"
								height="100%"
								src={selectedVideo.trailerLink}
								title="Trailer Video"
								frameBorder="0"
								allowFullScreen
							></iframe> */}

							<MuxVideoPlayer
								videoLink={selectedVideo?.muxTrailerLink}
								poster={selectedVideo?.trailerThumnailLink}
								storyboardToken={selectedVideo?.trailerStoryboardToken}
								videoCategory="Trailer"
								videoId={selectedVideo?._id}
								videoTitle={selectedVideo?.title}
							/>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default VideoTrailer;
